import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';

const EscalationMode = () => {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [{
            label: 'Top Escalation Channels',
            data: [],
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
        }]
    });

    useEffect(() => {
        const fetchEscalationMode = async () => {
            const querySnapshot = await getDocs(collection(db, "feedbacks"));
            const escalationTally = {};

            querySnapshot.forEach((doc) => {
                const escalationMode = doc.data().escalationMode;
                if (escalationTally[escalationMode]) {
                    escalationTally[escalationMode] += 1;
                } else {
                    escalationTally[escalationMode] = 1;
                }
            });

            // Use a functional update to avoid needing 'chartData' in the dependency array
            setChartData((prevData) => ({
                ...prevData,
                labels: Object.keys(escalationTally),
                datasets: [{
                    ...prevData.datasets[0],
                    data: Object.values(escalationTally),
                }]
            }));
        };

        fetchEscalationMode();
    }, []);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        indexAxis: 'y',
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 12,
                borderRadius: 8,
                titleFont: {
                    size: 14,
                    weight: 'bold',
                },
                bodyFont: {
                    size: 13,
                },
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                },
                ticks: {
                    font: {
                        size: 12,
                    },
                },
            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        size: 12,
                    },
                },
            },
        },
    };

    return (
        <div className="h-80">
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default EscalationMode;
